import { IExerciseOption } from '../types/interfaces/exercise-option';

/**
 * "(unit)" or "(unitKey)" when unit is absent — values come translated from API.
 */
export function getExerciseOptionUnitBracketSuffix(
  option: Pick<IExerciseOption, 'unit' | 'unitKey'>,
): string {
  const unit = option.unit?.trim();
  if (unit) return ` (${unit})`;
  const unitKey = option.unitKey?.trim();
  if (unitKey) return ` (${unitKey})`;
  return '';
}
